import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useAnimation from "../../../services/functions/useAnimation";
import useFetch from "../../../services/functions/useFetch";
import CustomAlert from "../../CustomAlert";
import snowflake from "../../../assets/icons/loading-snowflake.svg";
import skiKids from "../../../assets/pictures/ski4kids.png";
import skiAdults from "../../../assets/pictures/snowledge.png";

interface Skill {
  id: number;
  title: string;
}
interface SkillData {
  skills: Skill[];
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function MenuSkill() {
  const query = useQuery();
  const age = query.get("age") || 2; // if age is not set in URL, the routing comes from home-page ("Erwachsene"), so the default is 2
  const { slideIn, slideOutAll: slideOut } = useAnimation();
  const { data, error, isPending, fetchData } = useFetch<SkillData>();

  const userSelectedKids = () => {
    return localStorage.getItem("kids") === "true";
  };
  const toggleKids = async () => {
    const kids = userSelectedKids();
    localStorage.setItem("kids", (!kids).toString());
    await slideOut(".list__item", `/skill?age=${kids ? "2" : "1"}`);
  };

  useEffect(() => {
    slideIn(".list__item"); // * applying of smooth animation when elements appear
  }, [slideIn]);

  useEffect(() => {
    fetchData("/get/skills/", "GET", {
      doOnSuccess: () => {},
      doOnError: () => {
        console.error("Failed to fetch skills.");
      },
    });
  }, []);

  function getShadow(index: number) {
    if (index < 0 || index > 3 || isNaN(index)) return "";
    const values = [
      "list__item--first",
      "list__item--second",
      "list__item--third",
      "list__item--fourth",
    ];
    return values[index];
  }

  return (
    <>
      {error && <CustomAlert message={error} type="error" />}
      {isPending ? (
        <img src={snowflake} alt="loading" className="loading-snowflake" />
      ) : (
        <div>
          <ul className="page__list list">
            {data?.skills?.map((skill, index) => (
              <li className={"list__item " + getShadow(index)} key={skill.id}>
                <button
                  onClick={async () => {
                    await slideOut(
                      ".list__item",
                      `/list?age=${age}&skill=${skill.id}`
                    );
                  }} // * applying of smooth animation when elements disappear
                  className={"list__link"}
                  data-name={skill.title === "Konner" ? "Könner" : skill.title}
                >
                  {skill.title === "Konner" ? "Könner" : skill.title}
                </button>
              </li>
            ))}
          </ul>
          <button
            className="fixed-button"
            onClick={async () => {
              await toggleKids();
            }}
            onDragStart={(e) => e.preventDefault()}
          >
            <img
              src={userSelectedKids() ? skiAdults : skiKids}
              alt="Kids Icon"
              className="fixed-button__icon"
            />
            {/* <p>{userSelectedKids() ? "Erwachsene" : "Kids"}</p> */}
          </button>
        </div>
      )}
    </>
  );
}

export default MenuSkill;
